<template>
  <div class='time-chang x-d-flex'>

    <div class=" x-flex x-flex-1" :style="{ ...myStyle, maxWidth: maxWidth }">
      <el-date-picker v-model="dataTime" popper-class="noClear" :size='size' :picker-options="pickerOptions"
        type="datetimerange" :clearable="false" @change="setTime(dataTime)" value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
      </el-date-picker>
      <!-- <div class="x-w180">
        <el-date-picker style="width: 100%;" size="small" v-model="dataTime[0]"
        @change="setTime(dataTime,0)"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetime" placeholder="选择日期" :clearable="false">
        </el-date-picker>
      </div>
      <div class="x-w40 x-text-c">至</div>
      <div class="x-w180">
        <el-date-picker style="width: 100%;" size="small" v-model="dataTime[1]"
         @change="setTime(dataTime,1)" value-format="yyyy-MM-dd HH:mm:ss" 
         type="datetime" placeholder="选择日期" :clearable="false">
        </el-date-picker>
      </div> -->

    </div>
    <div class="x-d-flex x-m-l-10" v-if="showQuick">
      <!-- <el-button-group>
        <el-button  v-for="(item, index) in indexTimeData" :key="index" :size='size' 
          :type="indexTimeId == item.id ? 'primary' : ''"  plain @click="clickTime(item.id)">{{ item.name }}</el-button>
      </el-button-group> -->

      <el-radio-group v-model="indexTimeId" size="small" class="radio-plain">
        <el-radio-button v-for="(item, index) in indexTimeData" :label="item.id" :key="index">{{ item.name
        }}</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    from: {
      type: String,
      default: ''
    },
    showQuick: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    },
    maxWidth: {
      type: String,
      default: ''
    },
    myStyle: {
      type: Object,
      default: () => {
        return {
          // maxWidth: "330px;"
        }
      }
    },
    defaultTime: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          // {
          //   text: '昨日',
          //   onClick(picker) {
          //     const end = new Date();
          //     end.setHours(23, 59, 59, 999);
          //     end.setDate(end.getDate() - 1);
          //     const start = new Date(end);
          //     start.setHours(0, 0, 0, 0);
          //     picker.$emit('pick', [start, end]);
          //   }
          // },
          // {
          //   text: '今日',
          //   onClick(picker) {
          //     const end = new Date();
          //     end.setHours(23, 59, 59, 999);
          //     const start = new Date(end);
          //     start.setHours(0, 0, 0, 0);
          //     picker.$emit('pick', [start, end]);
          //   }
          // },
          {
            text: '近7日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近30日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              const end = new Date();
              const start = new Date(end);
              start.setDate(end.getDate() - end.getDay() + (end.getDay() === 0 ? -6 : 1));
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上周',
            onClick(picker) {
              const end = new Date();
              end.setDate(end.getDate() - end.getDay());
              end.setHours(23, 59, 59, 999);
              const start = new Date(end);
              start.setDate(end.getDate() - 6);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const end = new Date();
              end.setHours(23, 59, 59, 999);
              const start = new Date(end);
              start.setDate(1);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const end = new Date();
              end.setDate(0);
              end.setHours(23, 59, 59, 999);
              const start = new Date(end);
              start.setDate(1);
              start.setHours(0, 0, 0, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近3月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          // {
          //   text: '近六月',
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setMonth(start.getMonth() - 6);
          //     start.setHours(0, 0, 0, 0);
          //     end.setHours(23, 59, 59, 999);
          //     picker.$emit('pick', [start, end]);
          //   }
          // },
          {
            text: '本季',
            onClick(picker) {
              const end = new Date();
              const start = new Date(end);
              const quarter = Math.floor((start.getMonth() / 3));
              start.setMonth(quarter * 3, 1);
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上季',
            onClick(picker) {
              const end = new Date();
              const quarter = Math.floor((end.getMonth() / 3));
              const startMonth = quarter * 3 - 3;
              const start = new Date(end);
              start.setMonth(startMonth, 1);
              start.setHours(0, 0, 0, 0);
              end.setMonth(startMonth + 2, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本年',
            onClick(picker) {
              const end = new Date();
              const start = new Date(end);
              start.setMonth(0, 1);
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上年',
            onClick(picker) {
              const end = new Date();
              const start = new Date(end);
              start.setFullYear(start.getFullYear() - 1, 0, 1);
              start.setHours(0, 0, 0, 0);
              end.setFullYear(end.getFullYear() - 1, 11, 31);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近1年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setFullYear(start.getFullYear() - 1);
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      // 时间
      dataTime: [],
      startTime: '',
      endTime: '',
      indexTimeId: 6,
      indexTimeData: [{
        id: 6,
        name: "今日",
      }, {
        id: 2,
        name: "昨日",
      }, {
        id: 7,
        name: "本周",
      }, {
        id: 3,
        name: "本月",
      }, {
        id: 1,
        name: "上月"
      },],
    }
  },
  async created() {
    // 默认获取当日时间
    // this.dataTime=[this.api.timeHelper.fGetQhDay(0)+' 00:00:00',this.api.timeHelper.fGetNowTime(1)+' 23:59:59'];
    //deviceRecord 设备记录默认当日
    if (this.defaultTime) {
      this.clickTime(6)

    }
    console.log(this.myStyle)
  },
  computed: {},
  watch: {
    indexTimeId(newValue, oldValue) {
      this.clickTime(newValue)
    }
  },
  methods: {
    // 点击按钮切换时间选中状态
    clickTime(id) {
      this.indexTimeId = id;
      if (id == 0) {
        return
      }
      this.dataTime = []; //清空当前的时间
      if (id == 1) {
        this.dataTime = [this.api.timeHelper.getLastMonthStartDate() + ' 00:00:00', this.api.timeHelper
          .getLastMonthEndDate() + ' 23:59:59'
        ];
      } else if (id == 2) {
        this.dataTime = [this.api.timeHelper.fGetQhDay(-1) + ' 00:00:00', this.api.timeHelper.fGetQhDay(-1) +
          ' 23:59:59'
        ];
      } else if (id == 3) {
        this.dataTime = [this.api.timeHelper.getMonthStartDate() + ' 00:00:00', this.api.timeHelper
          .getMonthEndDate() + ' 23:59:59'
        ];
      } else if (id == 4) {
        this.dataTime = [this.api.timeHelper.fGetQhDay(-6) + ' 00:00:00', this.api.timeHelper.fGetNowTime(1) +
          ' 23:59:59'
        ];
      } else if (id == 5) {
        this.dataTime = [this.api.timeHelper.fGetQhDay(-30) + ' 00:00:00', this.api.timeHelper.fGetNowTime(1) +
          ' 23:59:59'
        ];
      } else if (id == 6) { //今日

        this.dataTime = [this.api.timeHelper.fGetQhDay(0) + ' 00:00:00', this.api.timeHelper.fGetQhDay(0) +
          ' 23:59:59'
        ];

      } else if (id == 7) { //本周

        this.dataTime = this.getWeekRange(0)
        console.log(this.dataTime)
      }


      if (Number(this.api.timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[0])) <= 20221230000000) {
        console.log(Number(this.api.timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[0])))
        // this.dataTime[0] = ['2022-12-30 00:00:00']
        // return this.$message.error('开始时间不能早于2022-12-30')
      }
      if (Number(this.api.timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[0]).substring(0, 4)) != Number(this.api
        .timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[1]).substring(0, 4))) {
        // this.dataTime[0] = ['2023-01-01 00:00:00']
        // return this.$message.error('不能跨年查询')
      }

      // 点击按钮切换数据 【传递给父组件】
      this.$emit('getTimeData', this.dataTime);
    },
    getWeekRange(offset = 0) {
      // offset=0:本周，-1:上周
      const now = new Date();
      const day = now.getDay() || 7; // 周日为0，转为7
      now.setHours(0, 0, 0, 0);
      // 本周一
      const monday = new Date(now);
      monday.setDate(now.getDate() - day + 2 + offset * 7);
      // 本周日
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      return [
        monday.toISOString().slice(0, 10) + " 00:00:00",
        sunday.toISOString().slice(0, 10) + " 23:59:59"
      ];
    },
    // 切换获取时间  【传递给父组件】
    setTime(time, index) {
      console.log(time, 'time')

      let starTime = this.api.timeHelper.fDateFat('yyyyMMddhhmmss', time[0])
      let overTime = this.api.timeHelper.fDateFat('yyyyMMddhhmmss', time[1])
      if (Number(starTime) <= 20221230000001) {
        return this.$message.error('开始时间不能早于2022-12-30')
      }
      // if (Number(starTime.substring(0, 4)) != Number(overTime.substring(0, 4))) {
      //   return this.$message.error('不能跨年查询')
      // }
      // this.dataTime[index] = time[index]
      this.indexTimeId = 0

      console.log(this.dataTime, 'dataTime')
      this.$emit('getTimeData', this.dataTime);
    },
  },
}
</script>
<style lang="less" scoped>
.time-chang {
  width: 100%;
  // flex-shrink: 0;
  // .el-button {
  //   padding: 0px;
  // }

  .el-button.is-plain:focus,
  .el-button.is-plain:hover {
    color: #6396fc;
    background: #fff;
    border-color: #6396fc;
  }

  /deep/ .el-input__inner {
    padding-right: 10px;
  }

  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
    // max-width: 330px;
  }


  // 选中状态
  .el-button--primary.is-plain {
    color: #6396fc;
    background: #fff;
    border-color: #6396fc;
    z-index: 1;
  }
}

.el-picker-panel__sidebar {
  padding-bottom: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/timeChang.vue